/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { getProxyUrl } from '../../utils/image';
import { useTicketConfig } from "../../hooks/ticket";

function SingleTeamTicket({ team, teamLogos }) {
    const [ticketConfig] = useTicketConfig(team?.abbrv);
    if (!ticketConfig) {
        return false;
    }
    const getTeamLogo = (abbrv) => {
        const team = teamLogos.find((x) => x.abbrv === abbrv);
        return getProxyUrl(team?.logo || team?.logoImageUrl, 100, 100);
    };
    const getArenaName = (abbrv) => {
        const team = teamLogos.find((x) => x.abbrv === abbrv);
        return team?.arena?.name || '';
    };

    return (
        <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="data-container data-container--gradient p-4 d-flex flex-column justify-content-center align-items-center">
                <img
                    style={{ maxHeight: 100 }}
                    className="team-ticket-logo mb-4"
                    src={getTeamLogo(team.abbrv)}
                    alt={team.abbrv}
                />
                <p className="heading-stats-name heading-stats-name--medium heading-name-ticket mt-0 mb-2 text-center">
                    {team.name}
                </p>
                <p className="text-caption mb-4">{getArenaName(team.abbrv)}</p>
                <div className="px-4 w-100">
                    <a
                        href={ticketConfig?.ticketUrl}
                        className="button button--primary-yellow button--large d-block text-center"
                    >
                        KÖP BILJETT
                    </a>
                </div>
            </div>
        </div>
    );
}
export default SingleTeamTicket;